import { Box, Button, Paper } from '@mui/material';
import { Link } from 'react-router-dom';
import React, { useContext, useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import Avatar from '../../assets/Images/DefaultAvatar.jpg';
import FilterIcon from '@mui/icons-material/Filter';
import Skeleton from '@mui/material/Skeleton';
import GroupsIcon from '@mui/icons-material/Groups';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import './Designer.css';
import Colors from '../../Constant/Colors';
import { UserContextData } from '../../context/AuthContext';
import client from '../../API/client';
import EditTwoToneIcon from '@mui/icons-material/EditTwoTone';

export const DesignerProfile = () => {
  const { Designer } = useContext(UserContextData);
  const [userprofile, setUserProfile] = useState([]);
  const [isData, setIsData] = useState(false);
  const [itemData, setItemData] = useState([]);
  const [profilepic, setProfilePic] = useState('');
  const [followers, setFollowers] = useState([]);
  const id = localStorage.getItem('user_id');
  useEffect(() => {
    getData();
    getConnection();
  }, []);

  const getConnection = async () => {
    try {
      await client.get(`/user/connections/followers/${id}`).then((res) => {
        setFollowers(res.data);
      });
    } catch (error) {
      console.log(error);
    }
  };

  const getData = async () => {
    const designer_id = await Designer.designer_id;
    const payload = { designer_id };
    try {
      await client
        .post(`/designer/profile`, payload, {
          headers: {
            'Content-Type': 'application/json',
          },
        })
        .then((res) => {
          console.log('Data - >>>>>>', res);
          setIsData(true);
          setUserProfile(res.data);
          setProfilePic(res.data[0].avatar);
        });
    } catch (error) {
      console.log('Error', error);
    }

    try {
      await client.get(`/user-profile/posts/${id}`, {}).then((res) => {
        // console.log(res.data);
        setItemData(res.data);
      });
    } catch (error) {
      console.log('Error', error);
    }
  };

  // const getPostData = async () =>{
  //   try {
  //     await client
  //       .get(`/user-profile/posts/${id}`,{
  //       })
  //       .then((res) => {
  //         console.log(res.data)
  //         setItemData(res.data);
  //       });
  //   } catch (error) {
  //     console.log('Error', error);
  //   }
  // }

  const avatarStyle = {
    backgroundImage: `url(${profilepic})`,
    backgroundSize: 'cover',
  };

  return (
    <>
      <div
        style={{
          height: '750px',
          overflow: 'scroll',
          backgroundColor: 'whitesmoke',
        }}>
        <Box m="10px">
          <Paper elevation={3} style={{ borderRadius: 20 }}>
            <div
              style={{
                backgroundColor: Colors.primary,
                height: '120px',
                width: '100%',
                textAlign: 'right',
              }}></div>
            <Row
              style={{
                alignItems: 'center',
                justifyContent: 'center',
                display: 'flex',
                padding: 20,
              }}>
              <Col style={{ marginLeft: '10px' }}>
                {profilepic === '' || profilepic === null ? (
                  <img
                    src={Avatar}
                    style={{
                      width: 140,
                      height: 140,
                      borderRadius: '0%',
                      objectFit: 'cover',
                      marginTop: -120,
                    }}
                  />
                ) : (
                  <img
                    src={profilepic}
                    style={{
                      width: 140,
                      height: 140,
                      borderRadius: '0%',
                      objectFit: 'cover',
                      marginTop: -120,
                    }}
                  />
                )}
                <h4 style={{ marginTop: '10px' }}>{isData ? userprofile[0].fullname : <Skeleton animation="wave" variant="rectangular" width={'50%'} height={40} />}</h4>
                <div style={{ marginTop: '5px' }}>
                  <span style={{ fontSize: '18px', fontWeight: '500' }}>
                    {isData ? userprofile[0].username : <Skeleton animation="wave" variant="rectangular" width={'30%'} height={20} />}
                  </span>
                </div>
                <div style={{ marginTop: '5px' }}>
                  <span style={{ fontSize: '18px' }}>
                    {isData ? 'Email :-' : ''} {isData ? userprofile[0].email : <Skeleton animation="wave" variant="rectangular" width={'30%'} height={20} />}
                  </span>
                </div>
                <Link to={`/designer/dashboard/Edit-profile/${Designer && Designer.designer_id}`} style={{ textDecoration: 'none' }}>
                  <Button
                    variant="contained"
                    sx={{
                      mr: '10px',
                      mt: '10px',
                      color: Colors.primary,
                      backgroundColor: Colors.secondary,
                      letterSpacing: 1,
                      '&:hover': {
                        backgroundColor: 'aquamarine',
                        color: Colors.darkpurple,
                      },
                    }}>
                    <EditTwoToneIcon
                      style={{
                        color: Colors.primary,
                        fontSize: '22px',
                        marginRight: '5px',
                      }}
                    />
                    Edit Profile
                  </Button>
                </Link>
              </Col>
              <Col className="profile-connection">
                <div
                  style={{
                    fontSize: '20px',
                    fontWeight: '500',
                    color: 'grey',
                  }}>
                  {itemData.length}
                </div>
                <div
                  style={{
                    fontSize: '20px',
                    fontWeight: '500',
                    color: Colors.primary,
                  }}>
                  {' '}
                  <FilterIcon style={{ color: Colors.darkpurple }} /> Post
                </div>
              </Col>

              <Col className="profile-connection">
                <div
                  style={{
                    fontSize: '20px',
                    fontWeight: '500',
                    color: 'grey',
                  }}>
                  {followers.length}
                </div>
                <div
                  style={{
                    fontSize: '20px',
                    fontWeight: '500',
                    color: Colors.primary,
                  }}>
                  {' '}
                  <GroupsIcon style={{ fontSize: '32', color: Colors.darkpurple }} /> Follower
                </div>
              </Col>
            </Row>
          </Paper>

          <Paper elevation={4} style={{ marginTop: '20px', padding: '10px', borderRadius: 20 }}>
            <Row style={{ marginLeft: '8px', marginRight: '18px' }}>
              <Col style={{ paddingBottom: '10px' }}>
                <h5 style={{ color: Colors.darkblue }}>Description</h5>
                <span style={{fontSize:'18px'}}>{isData ? userprofile[0].bio : <Skeleton animation="wave" variant="rectangular" width={'100%'} height={67} />}</span>
              </Col>
            </Row>
          </Paper>

          <Row style={{ marginTop: '20px' }}>
            <Col xs={7}>
              <Paper elevation={4} style={{ padding: '20px', borderRadius: 20 }}>
                <h5 style={{ color: Colors.darkblue }}>Posts</h5>
                <ImageList sx={{ width: '100%', height: 450 }} cols={3} rowHeight={164}>
                  {itemData.map((item) => (
                    <ImageListItem key={item.post_id}>
                      <img src={`${item.img}?w=164&h=164&fit=crop&auto=format`} srcSet={`${item.img}?w=164&h=164&fit=crop&auto=format&dpr=2 2x`} alt={item.title} loading="lazy" />
                    </ImageListItem>
                  ))}
                </ImageList>
              </Paper>
            </Col>
            <Col>
              <Row>
                <Paper elevation={4} style={{ padding: '20px', borderRadius: 20 }}>
                  <div>
                    <h5 style={{ color: Colors.darkblue }}>Skills</h5>
                    <span style={{fontSize:'18px'}}>{isData ? userprofile[0].skills : <Skeleton animation="wave" variant="rectangular" width={'100%'} height={40} />}</span>
                  </div>
                </Paper>
              </Row>
              <Row>
                <Paper
                  elevation={4}
                  style={{
                    padding: '20px',
                    borderRadius: 20,
                    marginTop: '20px',
                  }}>
                  <div>
                    <h5 style={{ color: Colors.darkblue }}>Portfolio Url</h5>
                    <span style={{fontSize:'18px'}}>
                      <a>{isData ? userprofile[0].portfolio : <Skeleton animation="wave" variant="rectangular" width={'100%'} height={40} />}</a>
                    </span>
                  </div>
                </Paper>
              </Row>
            </Col>
          </Row>
        </Box>
      </div>
    </>
  );
};
